var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg761X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "157px",
    height: "124px",
    viewBox: "0 0 157 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "76@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attitude-to-goals/3",
    transform: "translate(-110.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(110.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fill: "#F1EEEC",
    points: "135 70 123.526316 146.793354 16 146.793354 109 69"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fill: "#F1EEEC",
    points: "107 59 20 92 0 53 101 49"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fill: "#F1EEEC",
    transform: "translate(63.199310, 31.924998) rotate(5.000000) translate(-63.199310, -31.924998) ",
    points: "98.6993095 33.9249976 31.7249505 36.9249976 27.6993095 26.9249976 97.6993095 31.9249976"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fill: "#F1EEEC",
    points: "97 70.1794872 61.025641 92 58.0769231 83.7435897 95.2307692 69"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fill: "#F1EEEC",
    points: "144 92 149 126 140 126 141 92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(98.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.352625, 25.226234)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#CAC2BB",
    cx: 28.9152322,
    cy: 29.6204818,
    rx: 28.5626074,
    ry: 26.4468587
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9152322,2.82099827 C44.8788703,2.82099827 57.8304644,14.8132151 57.8304644,29.6204818 C57.8304644,44.4277485 44.8788703,56.4199653 28.9152322,56.4199653 C12.9515942,56.4199653 0,44.4277485 0,29.6204818 C0,14.8132151 12.9515942,2.82099827 28.9152322,2.82099827 Z M28.9152322,3.52624783 C13.3294853,3.52624783 0.705249566,15.215355 0.705249566,29.6204818 C0.705249566,44.0256086 13.3294853,55.7147157 28.9152322,55.7147157 C44.5009792,55.7147157 57.1252149,44.0256086 57.1252149,29.6204818 C57.1252149,15.215355 44.5009792,3.52624783 28.9152322,3.52624783 Z",
    id: "Oval",
    fill: "#CAC2BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9152322,
    cy: 26.7994835,
    rx: 28.5626074,
    ry: 26.4468587
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9152322,0 C44.8788703,0 57.8304644,11.9922168 57.8304644,26.7994835 C57.8304644,41.6067502 44.8788703,53.598967 28.9152322,53.598967 C12.9515942,53.598967 0,41.6067502 0,26.7994835 C0,11.9922168 12.9515942,0 28.9152322,0 Z M28.9152322,0.705249566 C13.3294853,0.705249566 0.705249566,12.3943567 0.705249566,26.7994835 C0.705249566,41.2046103 13.3294853,52.8937175 28.9152322,52.8937175 C44.5009792,52.8937175 57.1252149,41.2046103 57.1252149,26.7994835 C57.1252149,12.3943567 44.5009792,0.705249566 28.9152322,0.705249566 Z",
    id: "Oval",
    fill: "#CAC2BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 28.9152322,
    cy: 26.094234,
    rx: 23.6258605,
    ry: 21.8757967
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9152322,
    cy: 25.3889844,
    rx: 17.9838639,
    ry: 16.6517259
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 28.9152322,
    cy: 25.1277808,
    rx: 13.047117,
    ry: 12.0806639
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9152322,
    cy: 24.5792534,
    rx: 7.40512045,
    ry: 6.85659301
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 28.9152322,
    cy: 24.3441702,
    rx: 3.17362305,
    ry: 2.93853986
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 138,
    x2: 115,
    y2: 96,
    id: "Path-4",
    stroke: "#302745",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 138,
    x2: 58.5,
    y2: 102.5,
    id: "Path-53",
    stroke: "#302745",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 76,
    x2: 91,
    y2: 62,
    id: "Path-54",
    stroke: "#302745",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg761X);
export default __webpack_public_path__ + "static/media/76@1x.ceb65bf4.svg";
export { ForwardRef as ReactComponent };